import { FBD_Holding_Public } from '@rabbit/data/types';

export async function updateHoldingOnClose(caseId: string, holdingId: string) {
  //validation here

  const holdingDoc = await FBD_Holding_Public.get(holdingId);

  if (!holdingDoc) throw new Error('No holding document found with that id');

  const filteredActive =
    holdingDoc?.active_cases?.filter(
      (singleCase: string) => singleCase !== caseId
    ) ?? [];

  const closedCases = [...(holdingDoc?.closed_cases ?? []), caseId];

  holdingDoc.active_cases = filteredActive;
  holdingDoc.closed_cases = closedCases;
  
  await FBD_Holding_Public.set(holdingDoc);
}
